<template>
  <v-card-round @click="this.setSellerAndGoToClassificationsView" hover ripple>
    <v-container>
      <v-layout justify-center>
        <v-flex class="display-1 font-weight-light blue-grey--text" shrink>{{ name }}</v-flex>
      </v-layout>
    </v-container>
  </v-card-round>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("classifier");

import VCardRound from "@/components/cards/CardRound";

/**
 * A component that shows the seller's name and on click it sets the
 * `classificationsSellerId` in the store and goes to the classifications view.
 */
export default {
  components: {
    VCardRound
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions(["setClassificationsSellerId"]),
    async setSellerAndGoToClassificationsView() {
      this.setClassificationsSellerId(this.id);
      this.$router.push({
        name: "classifier/classifications",
        params: { classificationsSellerId: this.id }
      });
    }
  }
};
</script>